import {NavLink} from 'react-router-dom';

// Config
import {  enterpriseJobPostRoute, enterpriseTalentSourcingRoute } from '~config/routes';



export default function HeadNavigationEnterprise() {
    return (
        <nav className="header-enterprise-nav">
            <NavLink className="header-enterprise-nav__link" to={enterpriseTalentSourcingRoute}>
                <span className="header-enterprise-nav__label">Talent Sourcing</span>
            </NavLink>
            <NavLink className="header-enterprise-nav__link" to={enterpriseJobPostRoute}>
                <span className="header-enterprise-nav__label">Job posting</span>
            </NavLink>
        </nav>
    );
}
